import React from 'react';
import { Tabs, Button } from '@components';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export const PercentualContribuicaoPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = () => {
    if (location.pathname.includes('alterarPercentualContribuicao'))
      return 'Percentual de Contribuição';
    if (location.pathname.includes('intencaoMudancaPercentualContribuicao'))
      return 'Histórico de Intenção de Percentual de contribuição';
    if (location.pathname.includes('mudancaPercentualContribuicao'))
      return 'Histórico Mudança de Percentual de contribuição';
    return 'Percentual de Contribuição';
  };

  return (
    <>
      <Helmet>
        <title>Forluz - Percentual de Contribuição</title>
      </Helmet>
      <h1 className="fw-bold page-title mb-2">Percentual de Contribuição</h1>
      <hr />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32 mt-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <Tabs active={activeTab}>
        <div
          label="Percentual de Contribuição"
          onClick={() => navigate('alterarPercentualContribuicao')}
          aria-hidden
        >
          <Outlet />
        </div>
        <div
          label="Histórico de Intenção de Percentual de contribuição"
          onClick={() => navigate('intencaoMudancaPercentualContribuicao')}
          aria-hidden
        >
          <Outlet />
        </div>
        <div
          label="Histórico Mudança de Percentual de contribuição"
          onClick={() => navigate('mudancaPercentualContribuicao')}
          aria-hidden
        >
          <Outlet />
        </div>
      </Tabs>
    </>
  );
};
